import React, { useEffect, useRef, useState } from "react";
import "./LoadingWell.css";

// Gémeskút: T-betűs elrendezés, gyorsabb animáció, kar középről indul, hátrafelé is hosszabb
export default function LoadingWell({ loading_title = "Töltés...", minDuration = 1600, isLoaded = false, onFinish }) {
  const [minTimePassed, setMinTimePassed] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  // Reseteljük a minTimePassed-et minden új loading overlay megjelenéskor
  useEffect(() => {
    if (!isLoaded) {
      setMinTimePassed(false);
      setVideoLoaded(false);
    }
  }, [isLoaded]);

  useEffect(() => {
    if (!videoLoaded) return;
    const timer = setTimeout(() => setMinTimePassed(true), minDuration);
    return () => clearTimeout(timer);
  }, [minDuration, videoLoaded]);

  // Sötét mód detektálása
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const body = document.body;
    setIsDarkMode(body.classList.contains('dark-mode'));
    const observer = new MutationObserver(() => {
      setIsDarkMode(body.classList.contains('dark-mode'));
    });
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  // Akkor tűnik el, ha legalább 1.6mp eltelt, a videó betöltött ÉS isLoaded true
  const shouldHide = minTimePassed && videoLoaded && isLoaded;
  useEffect(() => {
    if (shouldHide && onFinish) onFinish();
  }, [shouldHide, onFinish]);

  if (shouldHide) return null;
  // Betűnként hullámzó szöveg
  const waveText = String(loading_title).split("").map((char, i) => (
    <span key={i} style={{ animationDelay: `${i * 0.08}s` }}>{char}</span>
  ));
  return (
    <div className="well-loading-outer">
      <video
        src={isDarkMode ? "/images/animation.webm" : "/images/animation.webm"}
        autoPlay
        loop
        muted
        className="well-loading-video"
        onLoadedData={() => setVideoLoaded(true)}
      />
      <div className="well-loading-text">{waveText}</div>
    </div>
  );
}
